// Comments are stored as text, but some carry HTML (tables, lists, links pasted
// in). They used to be rendered as-is, so a comment could run script. This keeps
// a small set of formatting tags, drops every attribute except a safe link href,
// and removes anything else (script, style, iframe, on* handlers...).

const ALLOWED = new Set([
  "A", "B", "BR", "CODE", "DIV", "EM", "H1", "H2", "H3", "H4", "I", "LI", "OL", "P", "PRE", "S", "SPAN",
  "STRONG", "SUB", "SUP", "TABLE", "TBODY", "TD", "TFOOT", "TH", "THEAD", "TR", "U", "UL", "BLOCKQUOTE", "HR",
]);
// Dropped together with everything inside them.
const DROP_WITH_CONTENT = new Set(["SCRIPT", "STYLE", "IFRAME", "OBJECT", "EMBED", "TEMPLATE", "NOSCRIPT", "SVG", "MATH", "LINK", "META"]);

const SAFE_HREF = /^(https?:|mailto:)/i;

const clean = (node, doc) => {
  [...node.childNodes].forEach(child => {
    if (child.nodeType === 3) return; // text
    if (child.nodeType !== 1) { child.remove(); return; } // comments etc.
    const tag = child.tagName.toUpperCase();
    if (DROP_WITH_CONTENT.has(tag)) { child.remove(); return; }
    clean(child, doc);
    if (!ALLOWED.has(tag)) {
      // Unknown tag: keep its text and allowed children, lose the tag itself.
      child.replaceWith(...child.childNodes);
      return;
    }
    const href = tag === "A" ? (child.getAttribute("href") || "").trim() : "";
    [...child.attributes].forEach(a => child.removeAttribute(a.name));
    if (tag === "A" && SAFE_HREF.test(href)) {
      child.setAttribute("href", href);
      child.setAttribute("target", "_blank");
      child.setAttribute("rel", "noopener noreferrer");
    }
  });
};

export const sanitizeHtml = (html = "") => {
  if (!html) return "";
  const doc = new DOMParser().parseFromString(`<body>${html}</body>`, "text/html");
  clean(doc.body, doc);
  return doc.body.innerHTML;
};

// True when the text carries markup; plain text keeps its line breaks instead.
export const looksLikeHtml = (text = "") => /<[a-z][a-z0-9]*(\s[^>]*)?\/?>|<\/[a-z][a-z0-9]*\s*>/i.test(text);

export default sanitizeHtml;